import { useMemo } from 'react';
import { ExternalLink } from '@components/Inputs';
import ItemTypeTab from '../../ItemTypes/ItemTypeGeneralTab';
import { WithTranslation, withTranslation } from 'react-i18next';
import { TextInput } from '@ts/storybook';
import { IForm, TMode } from '@ts/ui-models';
import { CElementType } from '@ts/ui-models';

interface FormMainAssetTypeProps extends WithTranslation, IForm {
  values: CElementType;
}

const FormMainAssetType = (props: FormMainAssetTypeProps) => {
  const { values, mode, t } = props;

  const isViewMode = mode === 'view';

  const rows = useMemo(
    () => [
      {
        id: 'name',
        name: t('Name'),
        value: () => (
          <TextInput isReadOnly={isViewMode} label="Name" value={values.name} onChangeValue={props.onCallbackChange('name')} />
        ),
      },
      {
        id: 'notes',
        name: t('Notes'),
        value: () => (
          <TextInput
            multiline
            isReadOnly={isViewMode}
            label="Notes"
            value={values.notes}
            onChangeValue={props.onCallbackChange('notes')}
          />
        ),
      },
      {
        id: 'externalHttpLink',
        name: t('External link'),
        value: () => (
          <ExternalLink
            key="link"
            linkLabel={t('URL Link')}
            captionLabel={t('URL Caption')}
            onChangeLink={props.onCallbackChange('externalHttpLink')}
            onChangeCaption={props.onCallbackChange('externalHttpLinkCaption')}
            url={values.externalHttpLink}
            caption={values.externalHttpLinkCaption}
            viewFields={mode === 'edit' || mode === 'new'}
            fDisabled={isViewMode}
          />
        ),
      },
      {
        id: 'externalHttpLink2',
        name: `${t('External link')} 2`,
        value: () => (
          <ExternalLink
            key="link2"
            linkLabel={`${t('URL Link')} 2`}
            captionLabel={t('URL Caption')}
            onChangeLink={props.onCallbackChange('externalHttpLink2')}
            onChangeCaption={props.onCallbackChange('externalHttpLinkCaption2')}
            url={values.externalHttpLink2}
            caption={values.externalHttpLinkCaption2}
            viewFields={mode === 'edit' || mode === 'new'}
            fDisabled={isViewMode}
          />
        ),
      },
      {
        id: 'externalHttpLink3',
        name: `${t('External link')} 3`,
        value: () => (
          <ExternalLink
            key="link3"
            linkLabel={`${t('URL Link')} 3`}
            captionLabel={t('URL Caption')}
            onChangeLink={props.onCallbackChange('externalHttpLink3')}
            onChangeCaption={props.onCallbackChange('externalHttpLinkCaption3')}
            url={values.externalHttpLink3}
            caption={values.externalHttpLinkCaption3}
            viewFields={mode === 'edit' || mode === 'new'}
            fDisabled={isViewMode}
          />
        ),
      },
    ],
    [values, mode, props.onCallbackChange]
  );

  return <ItemTypeTab {...props} rows={rows} />;
};

export default withTranslation()(FormMainAssetType);
